/**
 * @method pagerFactory.
 *
 *  example usage:

 import pagerFactory from '../common/pagingTable/pagerFactory';
 const ReportPager = pagerFactory('report');

render => (<ReportPager />)

 The above widget controls the stored list of reports with paging.
 */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pager from './pager';
import { actionRegistrar } from '../../../actions/entityActionRegistrar';

// need to change (or add a component below this?) this to be a react
// component so we can correctly bind actions
export default function pagerFactory(entity) {
  /*  ----------------------------------------------------
   + These methods allow you to massage variables into properties passed in
   + props to the component.
   +
   + The first takes the (global) redux state as input, and outputs just the
   + relevant parts to the compoment.
   + */
  const mapStateToProps = (state /* , incomingProps */) => {
    const entityState = state[entity];
    return {
      list: entityState.list,
      indexQuery: entityState.indexQuery,
      hasNext: entityState.hasNext,
      hasPrevious: entityState.hasPrevious,
      loading: entityState.loading
    };
  };

  // map the redux dipsatch mechanism into actions prop for this component.
  const mapDispatchToProps = dispatch => {
    const actions = actionRegistrar(entity);
    const boundActions = bindActionCreators(actions, dispatch);
    return {
      pagePrevious: boundActions.pagePrevious,
      pageNext: boundActions.pageNext
    };
  };

  // This wraps and instance of an entity in ConnectedClass and
  // connects it to the subset of the redux state as well as the action set
  return connect(mapStateToProps, mapDispatchToProps)(pager);
}